// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../raw-loader/index.js!../../postcss-loader/lib/index.js??embedded!./github.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../../style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../raw-loader/index.js!../../postcss-loader/lib/index.js??embedded!./github.css", function() {
			var newContent = require("!!../../raw-loader/index.js!../../postcss-loader/lib/index.js??embedded!./github.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/highlight.js/styles/github.css
// module id = ./node_modules/highlight.js/styles/github.css
// module chunks = styles